export const URL_FACEBOOK = "https://www.facebook.com/MouvyourBaudet"
export const URL_TWITTER = "https://www.twitter.com/mouvyourbaudet"
export const URL_SOUNDCLOUD = "https://soundcloud.com/mouvyourbaudet"
export const URL_SOUNDCLOUD_IFRAME = "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/users/179990628"
export const URL_YOUTUBE = (url) => `https://img.youtube.com/vi/${url}/hqdefault.jpg`



/** WEBPACK FOOTER **
 ** ./src/constants/urls.constants.js
 **/